import { Fragment } from "react";
import { useTenant } from "../../../../Context/Tenant/TenantContext";
import { SET_SEARCH_VALUE } from "../TenantEvents";
import { useTranslation } from "react-i18next";

const TenantSearchBar = () => {
    const { state, dispatch } = useTenant();

    const { t } = useTranslation([
        "tenant/tenant",
    ], {
        useSuspense: false
    })

    return (
        <Fragment>
            <input
                style={{ width: 250 }}
                type="text"
                value={state.searchValue}
                placeholder={t("search_tenant_users")}
                onChange={(e) => dispatch({ type: SET_SEARCH_VALUE, payload: e.target.value })}
                className="form-control unicode mx-1"
            />
        </Fragment>
    );
}

export default TenantSearchBar;